module.exports = __webpack_public_path__ + "dfb10834f39d571c795af7f3ffa053e1.svg";